import script from "./PendingPackagesConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingPackagesConfirm.vue?vue&type=script&setup=true&lang=js"

import "./PendingPackagesConfirm.vue?vue&type=style&index=0&id=21b309a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b309a4"]])

export default __exports__